<template>
    <div style="display: flex; align-items: center; width: 100%; padding-right: 12px;">
        <span>{{ headers.header_eign }}</span>
        <span class="ml-6">{{ headers.header_vat }}</span>
        <span v-if="headers.vat_exception" style="margin-left: auto; color: orange; background-color: rgba(255, 165, 0, 0.2); border: 1px solid orange; border-radius: 8px; padding: 4px 10px; display: inline-flex; align-items: center;">
            <v-icon color="orange" size="18" class="mr-2">mdi-alert</v-icon>VAT Exception
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            huov_encrid: String
        },
        components: {
        },
        data() {
            return {     
                headers: {},           
            }
        },
        created() {
            this.getHosmVatHeaders();
        },
        methods: {
            getHosmVatHeaders(){
                this.$axios
                    .post("ares/json/ares/huov/hosm/getHostVatHeader.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHostVatHeader"
                        },
                        getHostVatHeader: {
                            huov_encrid: this.huov_encrid,
                        }                        
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error.message);
                        } else {
                            this.headers = res.data.getHostVatHeader;
                        }
                    })
            },
        }
    }

</script>

<style scoped>

</style>